import { cn } from "../lib/utils";

const PRIORITY = {
  emergency: { color: "#FF3838", label: "Emergency" },
  medical: { color: "#00D2FF", label: "Medical" },
  public_safety: { color: "#FF8A00", label: "Public Safety" },
  premium: { color: "#FACC15", label: "Premium" },
  standard: { color: "#E4E4E7", label: "Standard" },
  background: { color: "#71717A", label: "Background" },
};

const STATUS = {
  online: { color: "#4ADE80", label: "Online", pulse: true },
  offline: { color: "#71717A", label: "Offline" },
  maintenance: { color: "#FFA800", label: "Maintenance" },
  active: { color: "#00E5FF", label: "Active", pulse: true },
  paused: { color: "#FACC15", label: "Paused" },
  completed: { color: "#4ADE80", label: "Completed" },
  normal: { color: "#4ADE80", label: "Normal" },
  warning: { color: "#FFA800", label: "Warning" },
  critical: { color: "#FF3838", label: "Critical", pulse: true },
};

export function StatusPill({ status, className }) {
  const meta = STATUS[status] || { color: "#71717A", label: status };
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded text-xs font-mono border border-zinc-800 bg-zinc-900/50",
        className
      )}
    >
      <span
        className={cn("bin-dot", meta.pulse && "bin-dot-pulse")}
        style={{ background: meta.color }}
      />
      <span style={{ color: meta.color }}>{meta.label}</span>
    </span>
  );
}

export function PriorityBadge({ priority, className }) {
  const meta = PRIORITY[priority] || PRIORITY.standard;
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded text-[0.65rem] font-mono uppercase tracking-wider border",
        className
      )}
      style={{
        color: meta.color,
        borderColor: `${meta.color}55`,
        background: `${meta.color}11`,
      }}
    >
      {meta.label}
    </span>
  );
}

export function SeverityPill({ severity }) {
  const map = {
    low: "#71717A",
    medium: "#FACC15",
    high: "#FFA800",
    critical: "#FF3838",
  };
  const color = map[severity] || "#71717A";
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded text-[0.65rem] font-mono uppercase tracking-wider border"
      style={{ color, borderColor: `${color}55`, background: `${color}11` }}
    >
      {severity}
    </span>
  );
}

export { PRIORITY, STATUS };
